export default __webpack_public_path__ + "static/media/uk-flag.fd46970f.svg";